/* eslint-disable */

import {useState} from 'react';
import './App.css';
import * as React from 'react';

function App() {
  let [글제목, 글제목변경] = useState(['남자 코트 추천', '강남 우동 맛집', '파이썬 독학']);
  let [따봉, 따봉변경] = useState([0, 0, 0]);
  let [작성일, 작성일변경] = useState(['2월 17일', '2월 17일', '2월 17일']);
  let [modal, setModal] = useState(false);
  let [title, setTitle] = useState(0);

  let [입력값, 입력값변경] = useState('');

  return (
    <div className="App">
      <div className="black-nav">
        <h4>React-Blog</h4>
      </div>
      {글제목.map(function (a, i) {
        //map 반복문 돌때마다, function 내 파라미터는 (array 안에 있던 데이터, 0부터 시작하는 인덱스)
        return (
          <div className="list" key={i}>
            <h4
              onClick={() => {
                setModal(true);
                setTitle(i);
              }}
            >
              {글제목[i]}
              <span
                onClick={(e) => {
                  e.stopPropagation(); //이벤트 버블링을 막아주세요
                  let copy = [...따봉];
                  copy[i] = copy[i] + 1;
                  따봉변경(copy);
                }}
              >
                👍
              </span>
              {따봉[i]}{' '}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  let copy = [[...글제목], [...따봉], [...작성일]];
                  copy[0].splice(i, 1);
                  copy[1].splice(i, 1);
                  copy[2].splice(i, 1);
                  글제목변경(copy[0]);
                  따봉변경(copy[1]);
                  작성일변경(copy[2]);
                }}
              >
                글 삭제
              </button>
            </h4>
            <p>
              <span>{작성일[i]}</span> 발행
            </p>
          </div>
        );
      })}

      <input
        onChange={(e) => {
          //파라미터 추가. 관습적으로 (Event의) e라고 함.
          입력값변경(e.target.value); // e.target = 해당 Event가 발생한 html 태그. 여기서는 요 <input /> 태그.
          //e.target.value = Event 발생한 html 태그에 입력한 값
        }}
      />
      <button
        onClick={() => {
          if (입력값 != '') {
            //함수 안에서는 일반 if 문 사용이 가능하구나!
            let copy = [[...글제목], [...따봉], [...작성일]];
            let today = new Date();
            copy[0].unshift(입력값);
            copy[1].unshift(0);
            copy[2].unshift(today.toISOString()); //표준시에 따라 ISO 8601 형식으로 주어진 날짜를 나타내는 문자열
            글제목변경(copy[0]);
            따봉변경(copy[1]);
            작성일변경(copy[2]);
          }
        }}
      >
        입력
      </button>
      {modal == true ? <Modal 글제목={글제목} modal={modal} title={title} /> : null}
    </div>
  );
}

function Modal(props) {
  var date = '날짜';
  //Component
  return (
    <div className="modal" style={{background: props.color}}>
      <h4>{props.글제목[props.title]}</h4>
      <p>날짜</p>
      <p>상세내용</p>
      <button>글수정👗</button>
    </div>
  );
}

export default App;

/* state 만드는 법, props 전송하는 법, 컴포넌트 만드는 법, UI 만드는 step 까먹지 말기 */
